import { render } from "./activity-enroll.vue?vue&type=template&id=35921047"
import script from "./activity-enroll.vue?vue&type=script&lang=js"
export * from "./activity-enroll.vue?vue&type=script&lang=js"

import "./activity-enroll.vue?vue&type=style&index=0&id=35921047&lang=scss"

import exportComponent from "/Users/chenjun/Desktop/myProject/pbl-web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__